<template>
  <div>
    <!-- 滑块的使用 -->
    <!-- <div class="boxEnds">
      <el-slider v-model="value2" :show-tooltip="false" class="sendS"></el-slider>
      <div class="piostde" :style="{left:value2+'%'}">{{value2}}%</div>
    </div>-->
    <el-button type="primary" icon="el-icon-edit" style="margin:20px" @click="addHnadn">新增设备</el-button>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266',textAlign: 'center' }"
      :row-class-name="tableRowClassName"
      :max-height="heagintH"
      border
    >
      <el-table-column prop="name" label="设备名称" align="center"></el-table-column>
      <el-table-column prop="onname" label="吸合动作名称" align="center"></el-table-column>
      <el-table-column prop="offname" label="断开动作名称" align="center"></el-table-column>
      <el-table-column prop="opengif1" label="继电器开启动画1">
        <template slot-scope="{row}">
          <el-image
            style="width: 100px; height: 100px"
            :src="row.opengif1"
            :preview-src-list="[row.opengif1]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="opengif2" label="继电器开启动画2">
        <template slot-scope="{row}">
          <el-image
            style="width: 100px; height: 100px"
            :src="row.opengif2"
            :preview-src-list="[row.opengif2]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="openpic" label="开启状态图片">
        <template slot-scope="{row}">
          <el-image
            style="width: 100px; height: 100px"
            :src="row.openpic"
            :preview-src-list="[row.openpic]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="closepic" label="关闭状态图片">
        <template slot-scope="{row}">
          <el-image
            style="width: 100px; height: 100px"
            :src="row.closepic"
            :preview-src-list="[row.closepic]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="supspendpic" label="中间状态图片">
        <template slot-scope="{row}">
          <el-image
            style="width: 100px; height: 100px"
            :src="row.supspendpic"
            :preview-src-list="[row.supspendpic]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="Istrip" label="是否监测行程量" align="center">
        <template slot-scope="{row}">{{row.Istrip == 0 ?'否' :'是'}}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="180" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" round icon="el-icon-edit" type="primary" @click="editFrom(row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" round @click='deleData(row)'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page-helper :page-data="pageData" :total="total" :get-table-list="PostJsonData"></page-helper>
    <el-dialog
    :close-on-click-modal="false"
    :modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      center
    >
      <!-- 插入的内容 -->
      <editFrom
        :rule-form="ruleForm"
        ref="fromeDIT"
        :postjsonData="PostJsonData"
        :updatehand="updatehand"
      />
    </el-dialog>
  </div>
</template>

<script>
import PageHelper from "@/components/common/PageHelper";
import { CamanetSet } from "../../network/lineRequest";
import { dealerDelete } from "../../network/index";
import editFrom from "./components/editFrom";
export default {
  components: {
    PageHelper,
    editFrom,
  },
  data() {
    return {
      ruleForm: {
        name: "",
        onname: "",
        offname: "",
        opengif1: "",
        opengif2: "",
        openpic: "",
        closepic: "",
        supspendpic: "",
        Istrip: "0",
      },
      widht: "40%",
      title: "",
      DateFrom: "",
      value2: 0,
      tableData: [],
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      total: null,
      dialogVisible: false,
    };
  },
  created() {},
  computed: {
    heagintH() {
      return window.innerHeight - 220;
    },
  },
  mounted() {
    this.PostJsonData();
  },
  methods: {
    // 删除
    deleData(row) {
      this.$confirm("此操作将永久删除该电用设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code, data, msg } = await dealerDelete(
            row.uuid,
            "tb_gateway_electric"
          );
          if (code) {
            this.PostJsonData()
            this.$message({
              type: "success",
              message: msg,
            });
          }else{
            this.$message.error(msg)
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑
    editFrom(row) {
      this.title = "修改电用设备";
      this.ruleForm = { ...row };
      this.dialogVisible = true;
    },
    // 新增
    addHnadn() {
      this.title = "新增电用设备";

      this.dialogVisible = true;
    },
    // 隐藏
    updatehand() {
      this.ruleForm = {};
      this.dialogVisible = false;
    },
    handleClose(done) {
      // this.updatehand()
      this.$refs.fromeDIT.handleClose();
       this.$refs.fromeDIT.showThend()
    },
    // 获取列表数据
    async PostJsonData() {
      const { code, data, msg } = await CamanetSet(this.pageData);
      if (code) {
        this.tableData = data.list;
        this.total = Number(data.pagelist[0].allrow);
      }
    },
    //   斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 滑块样式
.boxEnds {
  position: relative;
  width: 80%;
  margin: 0 auto;
  .piostde {
    position: absolute;
    margin-left: -6px;
    bottom: 30px;
  }
}
</style>
